module.exports = __webpack_public_path__ + "8d9a86c2b832fc125cc1f65088773b74.svg";